import { render, staticRenderFns } from "./ProductDiscountB2b.vue?vue&type=template&id=33b1bfbe"
import script from "./ProductDiscountB2b.vue?vue&type=script&lang=js"
export * from "./ProductDiscountB2b.vue?vue&type=script&lang=js"
import style0 from "./ProductDiscountB2b.vue?vue&type=style&index=0&id=33b1bfbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports